module.exports = __webpack_public_path__ + "media/images/common/3column_product_bg_nnn-8f29ee43bbff2a92ad6274f40513dae6.png";